module.exports = __webpack_public_path__ + "assets/img/script.68836e37.svg";